import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../../../../../utils/hooks/useMutationWithError";
import {
  UserContactStatus,
  useCheckUserPhoneStatusNotificationsMutation,
} from "./__generated__/useCheckUserPhoneStatusNotificationsMutation.graphql";

export const useCheckUserPhoneStatusNotifications = () => {
  const [checkStatus, isChecking] =
    useMutationWithError<useCheckUserPhoneStatusNotificationsMutation>(
      userCheckPhoneNotificationsMutationString
    );

  const { showToast } = useToast();

  const onCompletedErrorCustom = (errors: any) => {
    showToast({
      description: t`Whoops. Looks like you inserted an invalid phone number. Please try again.`,
      semanticStyle: "error",
      toastId: "loginError",
    });
    return [];
  };

  const checkPhone = (
    phoneNumber: string,
    onCompleteHandler: (
      value: string,
      result: UserContactStatus,
      type: "Phone"
    ) => void
  ) => {
    checkStatus({
      variables: { input: { phoneNumber } },
      onCompleted: (res) => {
        if (res.responsePayload?.success && res.responsePayload.result) {
          onCompleteHandler(phoneNumber, res.responsePayload.result, "Phone");
        }
      },
      onCompletedErrorCustom: (errors) => onCompletedErrorCustom(errors),
    });
  };
  return [checkPhone, isChecking] as const;
};

export const userCheckPhoneNotificationsMutationString = graphql`
  mutation useCheckUserPhoneStatusNotificationsMutation(
    $input: UserPhoneStatusInput!
  ) {
    responsePayload: userPhoneStatus(input: $input) {
      success
      result
      errors {
        field
        code
        message
      }
    }
  }
`;
